import Enums from "../../enums/enums";
import * as api from "../../service/ApiSevice";

export const actions = {
  CheckAffiliatesCampaign({ commit, state }, affiliateCampaignCode) {
    commit("MutationRestateAffiliates");
    commit("MutationBannerRestate");
    if (affiliateCampaignCode) {
      api.AffiliatesService.checkAffiliatesCampaign({
        campaignCode: affiliateCampaignCode
      }).then(res => {
        if (res.code !== Enums.HttpStatusCode.OK) {
          commit("MutationCheckAffiliateCampaign", res);
          commit("MutationCampaign", null);
        } else {
          commit("MutationCampaign", res.data);
          commit("MutationCheckAffiliateCampaign", {
            code: Enums.HttpStatusCode.OK,
            message: ""
          });
        }
      });
    }
  }
};
